import { colors } from "theme/Theme";
import React, { useCallback, useEffect } from "react";
import { MdChevronRight } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { DefaultText, smallShadow } from "theme/GlobalElements";
import CartElement from "./CartElement";
import {
  selectCurrentStep,
  setCurrentStep,
  updateCartData,
  selectCartReload,
} from "./cartSlice";
import { ProductCartItem } from "./types";
import userStorage from "store/UserStorage";

interface ProductCardItemsProps {}

const ProductCardItems: React.FC<ProductCardItemsProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reload = useSelector(selectCartReload);
  const cartItems = userStorage.getStoredInCart();
  const currentStep = useSelector(selectCurrentStep);

  const goHome = useCallback(() => {
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    cartItems.length === 0 && goHome();
  }, [cartItems, goHome]);

  const updateItem = (id: string, count: number) => {
    if (cartItems.length !== 0) {
      let newProductCardItems = [...cartItems];
      let element = cartItems.filter(
        (c: ProductCartItem) => c.product._id === id
      )[0];
      if (element) {
        let index = cartItems.indexOf(element);
        newProductCardItems.splice(index, 1);
        if (count === 0) {
          dispatch(updateCartData([...newProductCardItems]));
        } else {
          let newElement = { ...element };
          newElement.count = count;
          newProductCardItems.splice(index, 0, newElement);
          dispatch(updateCartData(newProductCardItems));
        }
      }
    }
  };

  const setNextStep = () => {
    dispatch(setCurrentStep(currentStep + 1));
  };

  const goBack = () => {
    if (currentStep === 1) {
      navigate(-1);
    } else {
      dispatch(setCurrentStep(currentStep - 1));
    }
  };

  return (
    <ProductCardItemsContainer>
      <>
        {cartItems.length > 0 ? (
          cartItems.map((citem: ProductCartItem, idx: number) => {
            return (
              <CartElement key={idx} item={citem} updateItem={updateItem} />
            );
          })
        ) : (
          <DefaultText
            style={{ padding: "10px", textAlign: "center" }}
            fontSize={16}
            fontWeight="600"
          >
            Количката ви е празна!
          </DefaultText>
        )}
      </>
      <Buttons>
        <Button className="back-button text-body" onClick={goBack}>
          <span>Обратно</span>
        </Button>
        <Button className="next-step-button text-body" onClick={setNextStep}>
          <span>Продължи</span>
          <MdChevronRight />
        </Button>
      </Buttons>
    </ProductCardItemsContainer>
  );
};

const ProductCardItemsContainer = styled.div`
  margin-top: 25px;
  display: flex;
  flex-flow: column;
  align-items: center;
`;

const Buttons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  margin: 15px 0;

  @media only screen and (${device.laptop}) {
    margin: 25px 0;
  }
`;

const FinalButton = styled(Buttons)`
  justify-content: center;
`;

const Button = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 5px 10px;
  cursor: pointer;
  ${smallShadow}

  &:nth-child(1) {
    margin-right: 10px;
  }

  &.back-button {
    background-color: white;
    outline: 1px solid ${colors.lighter_blue};
    color: ${colors.lighter_blue};
  }

  &.next-step-button,
  &.final-button {
    background-color: ${colors.lighter_blue};
    color: white;
  }

  &.final-button {
    justify-self: center;
  }

  @media only screen and (${device.laptop}) {
    padding: 10px 20px;
  }
`;

export default ProductCardItems;
